module.exports = {"theme":{"name":"dark-theme"}}


//////////////////
// WEBPACK FOOTER
// ./themeData/theme.json
// module id = 2056
// module chunks = 28